module.exports = __webpack_public_path__ + "static/media/people.c5b32b60.svg";